import styled from 'styled-components'
import { colors, fonts } from 'shared/lib'
import { t } from 'localization'

import Modal from 'shared/components/Modal'
import { Button } from 'shared/components/Button'
import { ClientOnlyPortal } from 'shared/components/ClientOnlyPortal'

const TP = 'checkout.panels.OrderSummary.ApplicableCostsModal'

type ApplicableCostsModalProps = {
  body: string
  isOpen: boolean
  onClose?: () => void
}

export const ApplicableCostsModal = ({ body, isOpen, onClose }: ApplicableCostsModalProps) => {
  if (!isOpen) return null

  return (
    <ClientOnlyPortal
      id="applicable-costs-modal"
      selector=".main-page-layout"
    >
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalContent>
          <Header data-qa="ApplicableCostsModalHeader">
            {t(`${TP}.applicableCosts`, 'Applicable Costs')}
          </Header>
          <Body data-qa="ApplicableCostsModalBody">{body}</Body>
          <OkButton
            $fill
            buttonType="primary1"
            onClick={onClose}
            qaAttr="ApplicableCostsModalOkButton"
            type="button"
          >
            {t(`${TP}.okButton`, 'Ok')}
          </OkButton>
        </ModalContent>
      </Modal>
    </ClientOnlyPortal>
  )
}

const ModalContent = styled.div`
  background-color: ${colors.FC2_WHITE};
  border: 1px solid ${colors.FC2_LIGHTEST_GREY};
  height: fit-content;
  padding: 20px;
  width: 100%;
`
const Header = styled.div`
  ${fonts.SUBTITLE_1}
  font-weight: 500;
  margin: 0 0;
`
const Body = styled.div`
  ${fonts.BODY_TEXT}
  color: ${colors.FC2_GREY};
  font-weight: 400;
  line-height: 18px;
  margin: 10px 0 0 0;
  text-align: left;
`
const OkButton = styled(Button)`
  margin: 40px 0px 10px 0px;
`
